module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_telephone_reserve-65379fd610fb2692a2ff9b3f14b9455c.svg";